export const startTour = (page: string) => {
  window.dispatchEvent(new CustomEvent("startTour", { detail: page }));
};

export const resetTour = () => {
  localStorage.removeItem("tour");
};
